import React, { Component } from 'react';
import { translate } from 'react-i18next';

import UserEditContainer from 'modules/profile/UserEditContainer.js'

const UserEditContainerWithText = props => <UserEditContainer {...props} headerText={props.t('Tell us a bit about you')} noNav />

export default translate('profile')(UserEditContainerWithText);




// WEBPACK FOOTER //
// ./src/modules/onboarding/PersonalContainer.js